export default "__VITE_ASSET__CMMdrZXS__"